import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Mail, Phone } from "lucide-react";
import { useSite, useMedia } from "@/context/SiteContext";
import { abs } from "@/lib/api";
import { DesktopNav } from "@/components/layout/DesktopNav";
import { MobileNav } from "@/components/layout/MobileNav";

export const useNavItems = () => {
  const site = useSite();
  return (site?.nav || []).map((item) =>
    item.children_source === "terminals" ? { ...item, children: site.terminals_nav } : item,
  );
};

const TopBar = ({ site }) => (
  <div className="hidden bg-navy-900 text-[13px] text-white/85 md:block">
    <div className="container-site flex h-9 items-center justify-between">
      <span data-testid="topbar-trade-registry">Ticaret Sicil No: {site.trade_registry_no}</span>
      <div className="flex items-center gap-6">
        <a href={`mailto:${site.email}`} className="inline-flex items-center gap-1.5 hover:text-white" data-testid="topbar-email-link">
          <Mail className="h-3.5 w-3.5" aria-hidden="true" /> {site.email}
        </a>
        <a href={site.phone_href} className="inline-flex items-center gap-1.5 hover:text-white" data-testid="topbar-phone-link">
          <Phone className="h-3.5 w-3.5" aria-hidden="true" /> {site.phone}
        </a>
      </div>
    </div>
  </div>
);

export const Header = () => {
  const site = useSite();
  const logo = useMedia(site.logo);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="sticky top-0 z-40 border-b border-line bg-white/95 backdrop-blur-md" data-testid="site-header">
      <TopBar site={site} />
      <div className="container-site flex h-[72px] items-center justify-between gap-6">
        <Link to="/" className="shrink-0" data-testid="header-logo-link" aria-label={`${site.company_display_name} — Ana Sayfa`}>
          {logo && (
            <img src={abs(logo.url)} width={logo.width} height={logo.height} alt={logo.alt}
              className="h-auto w-[168px] sm:w-[211px]" style={{ maxWidth: logo.width }} data-testid="header-logo" />
          )}
        </Link>
        <DesktopNav />
        <button type="button" className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-line text-navy xl:hidden"
          aria-expanded={open} aria-controls="mobil-menu" aria-label={open ? "Menüyü kapat" : "Menüyü aç"}
          onClick={() => setOpen((v) => !v)} data-testid="mobile-menu-toggle">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      {open && <MobileNav onNavigate={() => setOpen(false)} />}
    </header>
  );
};
